module.exports = __webpack_public_path__ + "static/img/6.0c27a886.jpg";